import { render, staticRenderFns } from "./RoadshowIndex.vue?vue&type=template&id=2782582e&scoped=true"
import script from "./RoadshowIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./RoadshowIndex.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RoadshowIndex.vue?vue&type=style&index=0&id=2782582e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2782582e",
  null
  
)

export default component.exports